var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-sm m-0 border" }, [
      _c(
        "tbody",
        [
          _vm._l(_vm.tasks, function (t) {
            return t.status === 3
              ? [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "pr-3",
                        attrs: {
                          rowspan:
                            t.task_data.conditions.filter(
                              (v) => +v.value && v.alias !== "interval"
                            ).length + 1,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(t.type_id === 28 ? "UTEKA" : "003sm") +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", {
                      staticClass: "zero_height",
                      attrs: { colspan: "6" },
                    }),
                  ]),
                  _vm._v(" "),
                  _vm._l(t.task_data.conditions, function (c, i) {
                    return +c.value && c.alias !== "interval"
                      ? _c(
                          "tr",
                          { class: { active: _vm.isConditionPass(c, t) } },
                          [
                            _c("td", [
                              _vm._v(
                                _vm._s(c.joinCondition === "and" ? "и" : "или")
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.title))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(c.condition === "more" ? ">" : "<")
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(c.value))]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                t.task_data.record
                                  ? [
                                      _c(
                                        "v-popover",
                                        { attrs: { "auto-hide": true } },
                                        [
                                          _c(
                                            "button",
                                            { staticClass: "btn btn-default" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-info icon-info",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "template",
                                            { slot: "popover" },
                                            [
                                              t.type_id === 30
                                                ? [
                                                    _c("SM003Statistics", {
                                                      attrs: {
                                                        stat: t.task_data
                                                          .record,
                                                      },
                                                    }),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              t.type_id === 28
                                                ? [
                                                    _c("p", [
                                                      _vm._v("UTEKA "),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: t.task_data
                                                              .record
                                                              .source_url,
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "icon-fa icon-fa-globe",
                                                          }),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("UtekaStatistics", {
                                                      attrs: {
                                                        stats:
                                                          t.task_data.record,
                                                      },
                                                    }),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        )
                      : _vm._e()
                  }),
                ]
              : _vm._e()
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }